<template>
    <div>
        <h3>小説の版を管理する</h3>
        <div>
            <p>
                小説のエピソードは、任意に「版」として管理することができます。
                保存時点の「版（バージョン）」へ任意に巻き戻すことができます。
            </p>
            <h4>版管理</h4>
            <p>
                エディタ右端の
                <i class="fas fa-code-branch"></i>
                アイコンから版管理サイドバーを表示できます。
            </p>
            <p>
                版は本文を編集することで、自動的に保存されるので、任意に保存する必要はありません。
                必要に応じて手動で現在の本文を新規の版として保存することができます。
                版には本文の最後の120文字が表示され、任意にコメントをつけることも可能です。
            </p>
            <img src="/img/help/novel/31.png" alt="版リスト" class="img-thumbnail mb-3">
            <p>
                「現在の版を保存する...」で版にコメントをつけて保存することができます。
                コメントは後で変更することができます。
            </p>
            <img src="/img/help/novel/30.png" alt="版保存" class="img-thumbnail mb-3">
            <p>
                保存した版はサイドバーに、新しい順にリストされます。
                版は最大で <b>{{$store.state.max_versions}} 件</b>まで保存できます。
                それを超えた場合、古い版から削除されます。
            </p>
            <p>
                保存した版は名前の変更と削除が可能です。
                左端の
                <i class="fas fa-edit"></i>
                アイコンから名前の変更を、
                右端の
                <i class="fas fa-times"></i>
                アイコンから削除を実行できます。
                また、版の名前をクリック・タップすると、現在の本文との比較ウインドウが開きます。
            </p>
            <img src="/img/help/novel/29.png" alt="元に戻す" class="img-thumbnail">
            <p>
                内容を確認して、本文を指定の版に戻すことができます。
                長編作品の場合はエピソードタイトルも対象となります。
                復元の差分表示は、差分のある行の前後だけが表示され、左に現在の版、
                右に選択した過去の版が並び、変更点がハイライトされます。
            </p>
            <p>
                <strong>
                    版を元に戻した場合、現在の本文は自動的に無題の版として保存されます。
                </strong>
                最新の版が現在の本文と同一の場合は自動保存は行われません。
                版を元に戻しても、版が削除されることはありません。
            </p>
            <h4>一括置換の履歴との違い</h4>
            <p>
                一括置換には、置換した変更内容をもとに戻す履歴機能があります。
                この履歴は版と異なり、一括置換の対象になった全てのエピソードが対象となり、
                操作を行った端末そのものに保存されます。
                そのため、編集する端末を変更すると、履歴は失われます。
                版とは別管理の履歴です。
            </p>
            <p>
                この変更を履歴から元に戻す操作を行った場合、指定履歴の時点に戻され、
                一括置換履歴は全て削除されます。
                詳細は <router-link to="/help/novel/episode">本文を記述する</router-link>
                から「検索と置換」を参照してください。
            </p>
            <p>
                版はユーザーが任意に保存するため、エピソード単位で履歴が保存されます。
                この履歴はサーバ側に保存されているため、編集する端末を変更しても失われることはありません。
                また、変更をもとに戻しても、（最大件数を超過しない限り）版が失われることはありません。
            </p>
            <p>
                <span class="text-danger">版と一括置換の履歴が入れ子の状態で、相互に「元に戻す」を実行しないでください。</span>
                結果が想定できない状態で元に戻す処理を繰り返すと、取り返しがつかなくなります。
                一括置換の「元に戻す」処理は、作業をミスしたときの救済策です。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "小説の順番を変更する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>